import React from 'react';
import { Table, Badge, Button } from 'react-bootstrap';

const MatchesInTable = ({ matches, onEditClick }) => {
  if (!matches || matches.length === 0) {
    return <p>Không có trận đấu nào trong vòng này.</p>;
  }

  return (
    <Table striped bordered hover responsive>
      <thead>
        <tr>
          <th>VĐV 1/2</th>
          <th>VĐV 3/4</th>
          <th>Tỷ số</th>
          <th>Hành động</th>
        </tr>
      </thead>
      <tbody>
        {matches.map((match) => (
          <tr key={match.id}>
            <td>
              <p className="mb-0"><strong>{match.p1_name}</strong></p>
              {match.math_type === 2 && match.p2_name && (<p className="mb-0 text-muted">{match.p2_name}</p>)}
            </td>
            <td>
              <p className="mb-0"><strong>{match.p3_name}</strong></p>
              {match.math_type === 2 && match.p4_name && (<p className="mb-0 text-muted">{match.p4_name}</p>)}
            </td>
            <td>
              <Badge bg={match.status === 1 ? "success" : "secondary"}>
                {match.status === 1 ? `${match.home_result} - ${match.guest_result}` : "Chưa thi đấu"}
              </Badge>
            </td>
            <td>
              {match.status !== 1 ? (
                <Button variant="outline-primary" size="sm" onClick={() => onEditClick(match)}>
                  Nhập kết quả
                </Button>
              ) : (
                <Button variant="outline-secondary" size="sm" onClick={() => onEditClick(match)}>
                  Xem chi tiết
                </Button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default MatchesInTable;
